export default "__VITE_PUBLIC_ASSET__2ee913a8__"